/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getCustomerProjectcostTable = params => {
  return axios.post(`${base}/query_projectcost`, params)
}
export const exportCustomerProjectcostData = params => {
  return axios.get(`${base}/exportCustomerProjectcostData/${params.id}`, {params})
}



// WEBPACK FOOTER //
// ./src/views/customer-projectcost/customer-projectcost.api.js